define(function (require) {
	// general
	const CN = require('civicsUtils/constants');
	// views
	const itemView = require('civicsViews/logs_view/v_itv_log_item');

	return Marionette.CollectionView.extend({
		initialize: function (options) {
			this.config = options.config;
			this.currentSort = options.currentSort;
			this.showAllItems = options.showAllItems;
			this.expanded = options.expanded;
		},
		tagName: 'div',
		className: 'list-container',
		childView: itemView,
		childViewOptions: function (model, index) {
			return {
				config: this.config,
				showAllItems: this.showAllItems,
				index: index,
				expanded: this.expanded
			};
		},
		ui: {},
		onRender: function () {
			if (__DEV__) console.log('cpv_logs onRender');
		},
	});
});
